import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const LoggerApi = createApi({
  reducerPath: "LoggerApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["LOGGERAPI"],
  endpoints: (build) => ({
    getLogs: build.query({
      query: ({
        page = 1,
        limit = 50,
        level,
        module,
        action,
        userId,
        adminId,
        startDate,
        endDate,
        searchTerm,
      }) => {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("limit", limit);
        if (level) params.append("level", level);
        if (module) params.append("module", module);
        if (action) params.append("action", action);
        if (userId) params.append("userId", userId);
        if (adminId) params.append("adminId", adminId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (searchTerm) params.append("searchTerm", searchTerm);

        return {
          url: `/logs?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      providesTags: ["LOGGERAPI"],
    }),
    getLogById: build.query({
      query: ({ id }) => ({
        url: `/logs/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["LOGGERAPI"],
    }),
    getErrorLogs: build.query({
      query: ({ limit = 100 }) => ({
        url: `/logs/errors?limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["LOGGERAPI"],
    }),

    // Get logs statistics
    getLogsStatistics: build.query({
      query: ({ startDate, endDate }) => {
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        return {
          url: `/logs/statistics?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      providesTags: ["LOGGERAPI"],
    }),

    // Get logs by user
    getLogsByUser: build.query({
      query: ({ userId, limit = 50 }) => ({
        url: `/logs/user/${userId}?limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["LOGGERAPI"],
    }),

    // Get logs by module
    getLogsByModule: build.query({
      query: ({ module, limit = 100 }) => ({
        url: `/logs/module/${module}?limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["LOGGERAPI"],
    }),

    // Delete old logs
    deleteOldLogs: build.mutation({
      query: ({ days = 90 }) => ({
        url: `/logs/cleanup?days=${days}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["LOGGERAPI"],
    }),

    // Export logs to CSV
    exportLogs: build.mutation({
      query: ({ startDate, endDate, level, module }) => {
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (level) params.append("level", level);
        if (module) params.append("module", module);

        return {
          url: `/logs/export?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "text/csv",
          },
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
});

export const {
  useGetLogsQuery,
  useGetLogByIdQuery,
  useGetErrorLogsQuery,
  useGetLogsStatisticsQuery,
  useGetLogsByUserQuery,
  useGetLogsByModuleQuery,
  useDeleteOldLogsMutation,
  useExportLogsMutation,
} = LoggerApi;
